import moment from 'moment';
import { type ChargePointUptimeSummary } from 'types/swagger';

// Chargepoint energy and transactions are the sum of those attributes for its connectors
export const getCalculatedUptimeAttributes = (uptimeSummary: ChargePointUptimeSummary) => {
  return uptimeSummary.connectors.reduce(
    (sum, connector) => ({
      transactions: sum.transactions + connector.transactions,
      energy: sum.energy + connector.energy,
    }),
    { transactions: 0, energy: 0 }
  );
};

export const getHrsFromPercentage = (hoursDifference: number, percentage: number) => {
  return hoursDifference ? Number(((hoursDifference * percentage) / 100).toFixed(1)) : 0;
};

export const formatDateForApi = (localeDate: string) => {
  const utcDate = moment.utc(localeDate);
  return [utcDate.month() + 1, utcDate.year()];
};

export const secondsToHoursMinutesSeconds = (
  totalSeconds: number
): {
  hours: number;
  minutes: number;
  seconds: number;
} => {
  const hours = Math.trunc(totalSeconds / 3600);
  const remainingSeconds: number = totalSeconds % 3600;
  const minutes: number = Math.trunc(remainingSeconds / 60);
  const seconds: number = remainingSeconds % 60;

  return { hours, minutes, seconds };
};

export const getTimeFromSeconds = (
  totalSeconds: number,
  percentage: number
): {
  hours: number;
  minutes: number;
  seconds: number;
} => {
  const timeBase = (percentage * totalSeconds) / 100;
  return secondsToHoursMinutesSeconds(timeBase);
};
